export const MasterMessage = {
    surveys: {
        titleList: 'Listado Encuestas',
        'SURVEY-ERROR-FIND':
            'Se presento un error al cargar el listado de encuestas',
        titleNew: 'Agregar Encuesta',
        'SURVEY-DUPLICATED': 'El código de la encuesta ya existe',
        'SURVEY-NEW-FAIL': 'Se presento un error al crear la encuesta',
        'SURVEY-NOT-FOUND': 'No se encontro la encuesta',
        titleEdit: 'Editar Encuesta',
        messageEdit: 'La encuesta fue actualizada exitosamente',
        'SURVEY-ERROR-UPDATE': 'Se presento un error al actualizar la encuesta',
        titleInactive: 'Deshabilitar Encuesta',
        messageInactive: 'Está seguro que desea deshabilitar la encuesta',
        messageInactiveOk: 'Se deshabilito la encuesta exitosamente',
        messageSurveyDisable:
            'La encuesta se encuentra deshabilitada. Para habilitarla, por favor contacte al administrador.',
        'SURVEY-ERROR-DELETE':
            'Se presento un error al deshabilitar la encuesta',
        questions: {
            'QUESTION-ERROR-FIND':
                'Se presento un error al cargar el listado  de encuestas',
            titleNew: 'Agregar Pregunta',
            messageNew: 'La pregunta fue creada exitosamente',
            'QUESTION-ERROR-SAVE': 'Se presento un error al crear la pregunta',
            'QUESTION-DUPLICATED': 'La pregunta ya existe',
            'QUESTION-NOT-FOUND': 'No se encontro la pregunta',
            titleEdit: 'Editar Pregunta',
            messageEdit: 'La pregunta fue actualizada exitosamente',
            'QUESTION-ERROR-UPDATE':
                'Se presento un error al actualizar la pregunta',
            titleInactive: 'Eliminar Pregunta',
            messageInactive: '¿Está seguro que desea eliminar la pregunta?',
            messageInactiveOk: 'Se eliminó la pregunta exitosamente',
            'QUESTION-ERROR-DELETE':
                'Se presento un error al eliminar la pregunta',
        },
        range: {
            titleNew: 'Agregar Rango',
            messageNew: 'El rango fue creada exitosamente',
            'ANSWER-ERROR-SAVE': 'Se presento un error al crear el rango',
            'ANSWER-ERROR-FIND':
                'Se presento un error en la busqueda del rango',
            'ANSWER-NOT-FOUND': 'No se encontro el rango',
            titleEdit: 'Editar Rango',
            messageEdit: 'El rango fue actualizado exitosamente',
            'ANSWER-ERROR-UPDATE':
                'Se presento un error al actualizar el rango',
        },
        answer: {
            titleNew: 'Agregar Respuesta',
            'ANSWER-ERROR-FIND':
                'Se presento un error en la busqueda de la respuesta',
            messageNew: 'La respuesta fue creada exitosamente',
            messageNewError: 'Se presento un error al crear la respuesta',
            titleEdit: 'Editar Respuesta',
            messageEdit: 'La respuesta fue actualizada exitosamente',
            messageEditError: 'Se presento un error al actualizar la respuesta',
            titleDelete: 'Deshabilitar Respuesta',
            messageInactive: 'Está seguro que desea deshabilitar la respuesta',
        },
        changePosition: {
            titleInactive: 'Cambiar posición',
            messageInactive:
                '¿Está seguro que desea mover esta pregunta de posición?',
            messageInactiveOk: 'Se movió la pregunta de posición exitosamente',
        },
    },
};
